import { useSnapshot } from '../state/TelephonyProvider'

const fmtWait = (s: number): string => {
  if (s <= 0) return '0:00'
  const m = Math.floor(s / 60)
  const r = s % 60
  return `${m}:${String(r).padStart(2, '0')}`
}

export function QueuesPanel() {
  const { queues } = useSnapshot()
  const anyStats = queues.some((q) => q.stats)
  return (
    <div className="sb-panel">
      {queues.length === 0 ? (
        <div className="sb-panel-empty">No queues.</div>
      ) : (
        queues.map((q) => (
          <div key={q.queue} className="list-row row">
            <span><strong>{q.queue}</strong></span>
            <span className="muted">
              {q.stats
                ? `${q.stats.callsWaiting} waiting · ${fmtWait(q.stats.longestWaitSeconds)} longest · ${q.agents} agents`
                : `${q.agents} agents · ${q.available} avail · ${q.paused} paused`}
            </span>
          </div>
        ))
      )}
      {!anyStats && queues.length > 0 && (
        <div className="faint" style={{ marginTop: 8, fontSize: 11 }}>
          Waiting / longest-wait bind to the contract’s queue_stats event (ACD wallboard); the
          engine emits it in a follow-up pass.
        </div>
      )}
    </div>
  )
}
